/**
 * @param instance {AxiosInstance}
 * @returns {{calc(*): *}}
 */
export default (instance) => ({
  calc(payload) {
    return instance.post('/calc', payload);
  },
});
